import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { adminService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as conheaderActions from './action';

export function saveConnectionHeader(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_CONNECTION_HEADER),
    mergeMap(({ payload }) => {
      return adminService.saveConnectionHeader(payload)
        .pipe(
          map(res => conheaderActions.saveConnectionHeaderSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function updateConnectionHeader(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_CONNECTION_HEADER),
    mergeMap(({ payload }) => {
      return adminService.updateConnectionHeader(payload)
        .pipe(
          map(res => conheaderActions.updateConnectionHeaderSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}

export function fetchConnectionHeaders(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_CONNECTION_HEADERS),
    mergeMap(({ payload }) => {
      return adminService.fetchConnectionHeader(payload)
        .pipe(
          map(res => conheaderActions.fetchConnectionHeadersSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function deleteConnectionHeader(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE_CONNECTION_HEADER),
    mergeMap(({ payload }) => {
      return adminService.deleteConnectionHeader(payload)
        .pipe(
          map(res => conheaderActions.deleteConnectionHeaderSuccess(payload)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}